// extracted by mini-css-extract-plugin
export default {"nav_list":"NavigationLinks_nav_list__Nm8ce","nav_item":"NavigationLinks_nav_item__BCjXt","active":"NavigationLinks_active__MefcJ"};